import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  contentId: null,
  fieldsConfig: [],
  fieldsLines: {},
  masterChannelValues: {},
  errors: [],
  flags: {},
  master: {},
  draft: {},
  finished: false,
  previewUrl: null,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
